if (!customElements.get('gr-location-menu')) {
  customElements.define('gr-location-menu', class locationMenu extends HTMLElement {
      constructor() {
          super();
      }

      connectedCallback() {
         this.menus = Array.from(this.querySelectorAll(".js-location-menu__menu"));

         this.mobileColumn = this.querySelector(".js-location-menu__mobile-wrapper");

         this.tabletLeftCol = this.querySelector(".js-location-menu__tablet-left-wrapper");
         this.tabletRightCol = this.querySelector(".js-location-menu__tablet-right-wrapper")

         this.desktopLeftCol = this.querySelector(".js-location-menu__desktop-left-wrapper");
         this.desktopCenterCol = this.querySelector(".js-location-menu__desktop-center-wrapper");
         this.desktopRightCol = this.querySelector(".js-location-menu__desktop-right-wrapper");

         this.updateLayout()

         window.addEventListener('resize', this.updateLayout);
      };

      disconnectedCallback() {
        window.removeEventListener('resize', this.updateLayout);
      }

      updateLayout = () => {
        this.mobileColumn.innerHTML = "";

        this.tabletLeftCol.innerHTML = ''
        this.tabletRightCol.innerHTML = ''

        this.desktopLeftCol.innerHTML = ''
        this.desktopCenterCol.innerHTML = '' 
        this.desktopRightCol.innerHTML = ''


        if (window.innerWidth < 768) {
          this.menus.forEach(menu => {
            this.mobileColumn.append(menu);
          })
        } else if (window.innerWidth >= 768 && window.innerWidth < 1200) {
          this.menus.forEach(menu => {
            if(menu.dataset.tablet == "left") {
              this.tabletLeftCol.append(menu);
            } else {
              this.tabletRightCol.append(menu);
            }
          })
        } else {
          this.menus.forEach(menu => {
            if(menu.dataset.desktop == "left") {
              this.desktopLeftCol.append(menu);
            } else if(menu.dataset.desktop == "right") {
              this.desktopRightCol.append(menu);
            }else {
              this.desktopCenterCol.append(menu);
            }
          })
        }
      }
  });
}
